export enum PartnerSessionDetailsTabs {
  SESSION_DETAILS = 'Session Details',
  MESSAGES = 'Messages',
  FILES_MANAGEMENT = 'Files Management'
}
